const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function assetUrl(src) {
  if (!src) return null;
  return src.startsWith("/api/") ? `${BACKEND}${src}` : src;
}

export function resolveTile(item, mb, project) {
  if (!item) return null;
  if (item.type === "hero") return assetUrl(mb.hero_image);
  if (item.type === "ai") return assetUrl(item.url);
  if (item.type === "client") return assetUrl(project?.images?.find(i => i.id === item.id)?.data_url);
  return item.url || null;
}

export function leadImage(mb, project) {
  const g = mb.gallery || [];
  for (const item of g) {
    const src = resolveTile(item, mb, project);
    if (src) return src;
  }
  return assetUrl(mb.hero_image);
}
